import dbRepository from "./dbRepository";

function publish(name, detail) {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") return;
  window.dispatchEvent(new CustomEvent(name, { detail }));
}

function update(date, generatedRepeatingEvents) {
  const run = async () => {
    const { requireOnline, saveRepeatingEventByDate } = require("../sync/sessionSync.js");
    requireOnline();
    return saveRepeatingEventByDate(date, generatedRepeatingEvents);
  };
  return run().catch((error) => {
    const message =
      (error && error.code === "OFFLINE" && "网络不可用") ||
      (error && error.message) ||
      "同步失败";
    publish("sync-write-failed", {
      docType: "repeating_event_by_date",
      docId: String(date),
      message,
    });
    throw error;
  });
}

function remove(date) {
  let db_req = dbRepository.open();
  db_req.onsuccess = function (event) {
    let db = event.target.result;
    dbRepository.delete(db, "repeating_events_by_date", date);
  };
}

export default {
  update,
  remove,
};
